/* eslint-disable no-undef */
import * as ng from 'angular';

export const ContextMenu: ng.IDirectiveFactory = ($parse: any, $q: any) => {

  const contextMenus = [];
  let $currentContextMenu = null;
  const removeContextMenus = (level?: any) => {
    while (contextMenus.length && (!level || contextMenus.length > level)) {
      contextMenus.pop().remove();
    }
    if (contextMenus.length === 0 && $currentContextMenu) {
      $currentContextMenu.remove();
    }
  };
  const renderContextMenu = ($scope: any, event: any, options: any, model: any, level?: any) => {
    if (!level) {
      level = 0;
    }
    if (!$) {
      const $ = ng.element;
    }
    $(event.currentTarget).addClass('context');
    let $contextMenu = $('<div>');
    if ($currentContextMenu) {
      $contextMenu = $currentContextMenu;
    } else {
      $currentContextMenu = $contextMenu;
    }
    $contextMenu.addClass('dropdown clearfix');
    const $ul = $('<ul>');
    $ul.addClass('dropdown-menu context-menu');
    $ul.attr({role: 'menu'});
    $ul.css({
      display: 'block',
      position: 'absolute',
      left: event.pageX + 'px',
      top: event.pageY + 'px',
      'z-index': 10000
    });
    const $promises = [];
    ng.forEach(options, (item, i) => {
      const $li = $('<li>');
      if (item === null) {
        $li.addClass('divider');
      } else {
        const nestedMenu = ng.isArray(item[1]) ?
          item[1] : ng.isArray(item[2]) ?
            item[2] : ng.isArray(item[3]) ?
              item[3] : null;
        const $a = $('<a>');
        $a.css('padding-right', '8px');
        $a.attr({tabindex: '-1', href: '#'});
        const text = typeof item[0] === 'string' ? item[0] : item[0].call($scope, $scope, event, model);
        const $promise = $q.when(text);
        $promises.push($promise);
        $promise.then(text => {
          $a.html(text);
          if (nestedMenu) {
            $a.css('cursor', 'default');
            $a.append($('<strong style="font-family:monospace;font-weight:bold;float:right;">&gt;</strong>'));
          }
        });
        $li.append($a);
        const enabled = ng.isFunction(item[2]) ? item[2].call($scope, $scope, event, model, text) : true;
        if (enabled) {
          const openNestedMenu = $event => {
            removeContextMenus(level + 1);
            const ev = {
              pageX: event.pageX + $ul[0].offsetWidth - 1,
              pageY: $ul[0].offsetTop + $li[0].offsetTop - 3
            };
            renderContextMenu($scope, ev, nestedMenu, model, level + 1);
          };
          $li.on('click', $event => {
            $event.preventDefault();
            $scope.$apply(() => {
              if (nestedMenu) {
                openNestedMenu($event);
              } else {
                $(event.currentTarget).removeClass('context');
                removeContextMenus();
                item[1].call($scope, $scope, event, model, text);
              }
            });
          });
          $li.on('mouseover', $event => {
            $scope.$apply(() => {
              if (nestedMenu) {
                openNestedMenu($event);
              }
            });
          });
        } else {
          $li.on('click', $event => {
            $event.preventDefault();
          });
          $li.addClass('disabled');
        }
      }
      $ul.append($li);
    });
    $contextMenu.append($ul);
    const height = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );
    $contextMenu.css({
      width: '100%',
      height: height + 'px',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 9999
    });
    $(document).find('body').append($contextMenu);
    // calculate if drop down menu would go out of screen at left or bottom
    // calculation need to be done after element has been added (and all texts are set; thus thepromises)
    // to the DOM the get the actual height
    $q.all($promises).then(() => {
      if (level === 0) {
        let topCoordinate = event.pageY;
        const menuHeight = ng.element($ul[0]).prop('offsetHeight');
        const winHeight = event.view.innerHeight;
        if (topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight) {
          topCoordinate = event.pageY - menuHeight;
        }

        let leftCoordinate = event.pageX;
        const menuWidth = ng.element($ul[0]).prop('offsetWidth');
        const winWidth = event.view.innerWidth;
        if (leftCoordinate > menuWidth && winWidth - leftCoordinate < menuWidth) {
          leftCoordinate = event.pageX - menuWidth;
        }

        $ul.css({
          display: 'block',
          position: 'absolute',
          left: leftCoordinate + 'px',
          top: topCoordinate + 'px'
        });
      }
    });
    $contextMenu.on('mousedown', e => {
      if ($(e.target).hasClass('dropdown')) {
        $(event.currentTarget).removeClass('context');
        removeContextMenus();
      }
    }).on('contextmenu', event => {
      $(event.currentTarget).removeClass('context');
      event.preventDefault();
      removeContextMenus(level);
    });
    $scope.$on('$destroy', () => {
      removeContextMenus();
    });
    contextMenus.push($ul);
  };
  return ($scope, element, attrs) => {
    element.on('contextmenu', event => {
      event.stopPropagation();
      $scope.$apply(() => {
        event.preventDefault();
        var options = $scope.$eval(attrs.contextMenu);
        var model = $scope.$eval(attrs.model);
        if (options instanceof Array) {
          if (options.length === 0) {
            return;
          }
          renderContextMenu($scope, event, options, model);
        } else {
          throw '"' + attrs.contextMenu + '" not an array';
        }
      });
    });
  };
};

ContextMenu.$inject = ['$parse', '$q'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/context-menu/context-menu.directive.ts